import { Ability } from '@casl/ability'
import { initialAbility } from './initialAbility'

//  Read ability from localStorage
// * Handles auto fetching previous abilities if already logged in user
// ? You can update this if you store user abilities to more secure place
// ! Anyone can update localStorage so be careful and please update this
let userData = {}
try {
  const raw = localStorage.getItem('userData')
  if (raw && raw !== 'undefined') userData = JSON.parse(raw)
} catch (e) {
  userData = {}
}

const existingAbility = userData && userData.ability ? userData.ability : null

export default new Ability(existingAbility || initialAbility)
